import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import SoftButton from 'components/SoftButton';
import SoftInput from 'components/SoftInput';
import SoftTypography from 'components/SoftTypography';
import Grid from '@mui/material/Grid';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';

const ModalTrafficHeader = ({ show, handleClose, initialData }) => {
  const { numeroOrdenDetalle } = useParams();
  const [formData, setFormData] = useState({
    op: '',
    documento: ''
  });

  useEffect(() => {
    // Si initialData es un array, extraemos el primer elemento
    const editingData = Array.isArray(initialData) ? initialData[0] : initialData;
    if (editingData && (editingData.id_trafico || editingData.id)) {
      const idToFetch = editingData.id_trafico || editingData.id;
      axios
        .get(`${process.env.REACT_APP_SERVER_URL}/api/orders/traffic-header-info/`, {
          params: { id: idToFetch }
        })
        .then(response => {
          // Si la respuesta es un array, tomamos el primer elemento
          const apiData = Array.isArray(response.data)
            ? response.data[0]
            : response.data;
          console.log("Datos obtenidos para edición:", apiData);
          setFormData({
            op: apiData.op || '',
            documento: apiData.doc || apiData.documento || ''
          });
        })
        .catch(error => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error al obtener los datos del tráfico.'
          });
          console.error("Error fetching traffic header info:", error);
        });
    } else {
      // Modo agregar
      setFormData({
        op: '',
        documento: ''
      });
    }
  }, [initialData, show]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Usamos editingData para determinar el modo edición
  const editingData = Array.isArray(initialData) ? initialData[0] : initialData;
  const isEditing = editingData && (editingData.id_trafico || editingData.id);

  // Función que guarda los datos:
  // - Si estamos en modo edición, se envía un PATCH al endpoint usando el id del tráfico.
  // - En modo agregar, se envía un POST usando el id de la orden.
  const handleSave = () => {
    // Validación básica
    if (!formData.op || !formData.documento) {
      Swal.fire({
        icon: 'error',
        title: 'Campos incompletos',
        text: 'Debe completar los campos de OP y HAWB o BL.'
      });
      return;
    }

    const postData = {
      id: isEditing ? (editingData.id_trafico || editingData.id) : numeroOrdenDetalle,
      op: formData.op,
      doc: formData.documento
    };

    if (isEditing) {
      axios
        .patch(`${process.env.REACT_APP_SERVER_URL}/api/orders/traffic-header/`, postData)
        .then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Actualizado',
            text: 'El tráfico ha sido actualizado con éxito!'
          });
          handleClose();
        })
        .catch(error => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error actualizando tráfico. Inténtelo nuevamente.'
          });
          console.error("Error actualizando tráfico cabecera:", error);
        });
    } else {
      axios
        .post(`${process.env.REACT_APP_SERVER_URL}/api/orders/traffic-header/`, postData)
        .then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Guardado',
            text: 'El tráfico ha sido ingresado con éxito!'
          });
          handleClose();
        })
        .catch(error => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error guardando tráfico cabecera. Inténtelo nuevamente.'
          });
          console.error("Error guardando tráfico cabecera:", error);
        });
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {isEditing ? 'Editar Trafico Cabecera' : 'Agregar Trafico Cabecera'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <SoftTypography variant="caption" fontWeight="bold" color="text">
              Op o Consolidado
            </SoftTypography>
            <SoftInput
              type="text"
              id="txtop"
              name="op"
              placeholder="Ingrese OP o Consolidado"
              value={formData.op}
              onChange={handleInputChange}
              icon="fas fa-hashtag"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <SoftTypography variant="caption" fontWeight="bold" color="text">
              HAWB o BL
            </SoftTypography>
            <SoftInput
              type="text"
              id="txtdocumento"
              name="documento"
              placeholder="Ingrese HAWB o BL"
              value={formData.documento}
              onChange={handleInputChange}
              icon="fas fa-hashtag"
            />
          </Grid>
        </Grid>
      </Modal.Body>
      <Modal.Footer>
        <SoftButton variant="gradient" color="success" onClick={handleSave}>
          Guardar
        </SoftButton>
        <SoftButton variant="gradient" color="error" onClick={handleClose}>
          Cancelar
        </SoftButton>
      </Modal.Footer>
    </Modal>
  );
};

ModalTrafficHeader.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  initialData: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};

export default ModalTrafficHeader;
